import { render, staticRenderFns } from "./EditableElement.vue?vue&type=template&id=745a1572&lang=pug&"
import script from "./EditableElement.vue?vue&type=script&lang=js&"
export * from "./EditableElement.vue?vue&type=script&lang=js&"
import style0 from "./EditableElement.vue?vue&type=style&index=0&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VHover,VIcon})
